/**
 * Italian Roots Discovery — Legal identity (single source of truth).
 *
 * All legal disclosures across the site (Footer, DatiLegaliPage, Privacy,
 * Cookie, Terms) must read from this module to guarantee consistency.
 *
 * Source documents:
 *  - Certificato di attribuzione del numero di partita IVA (Agenzia delle Entrate)
 *  - Visura Camerale (CCIAA Cremona-Mantova-Pavia)
 */
export const LEGAL_IDENTITY = {
  denomination: 'Italian Roots Discovery di Caliò Giosia',
  legalForm: {
    it: 'Impresa individuale',
    en: 'Sole proprietorship',
    es: 'Empresa individual',
    pt: 'Empresa em nome individual',
  },
  vatId: '03037540188',      // Partita IVA (also = fiscal code for sole proprietorships)
  fiscalCode: '03037540188',
  owner: 'Giosia Caliò',
  rea: 'PV - 340804',
  cciaa: 'Cremona-Mantova-Pavia',
  pec: 'giosia.calio@postecertifica.it',
  publicEmail: 'italianrootsdiscovery@gmail.com',
  registryDate: '21/04/2026',
  ateco: {
    code: '911200',
    label: {
      it: 'Gestione di archivi (ATECO 911200)',
      en: 'Archives activities (ATECO 911200)',
      es: 'Gestión de archivos (ATECO 911200)',
      pt: 'Gestão de arquivos (ATECO 911200)',
    },
  },
  registeredOffice: {
    street: 'Località Villa Marone, 1',
    zip: '27040',
    city: 'Borgo Priolo',
    province: 'PV',
    country: {
      it: 'Italia',
      en: 'Italy',
      es: 'Italia',
      pt: 'Itália',
    },
  },
};

/** Compact one-liner used in the footer legal strip. */
export const legalFooterLine = () => {
  const L = LEGAL_IDENTITY;
  return `${L.denomination} · P.IVA ${L.vatId} · REA ${L.rea} · PEC ${L.pec} · ${L.registeredOffice.street}, ${L.registeredOffice.zip} ${L.registeredOffice.city} (${L.registeredOffice.province})`;
};

/** Full "Data Controller" block for Privacy Policy (GDPR art. 13). */
export const dataControllerBlock = (lang = 'it') => {
  const L = LEGAL_IDENTITY;
  const addr = `${L.registeredOffice.street}, ${L.registeredOffice.zip} ${L.registeredOffice.city} (${L.registeredOffice.province}), ${L.registeredOffice.country[lang] || L.registeredOffice.country.it}`;
  const map = {
    it: `Il Titolare del trattamento dei dati personali è ${L.denomination} (${L.legalForm.it}), P.IVA ${L.vatId}, REA ${L.rea} (CCIAA ${L.cciaa}), con sede legale in ${addr}. Legale rappresentante: ${L.owner}. Contatti: PEC ${L.pec} — email ${L.publicEmail}.`,
    en: `The Data Controller is ${L.denomination} (${L.legalForm.en}), VAT No. ${L.vatId}, REA ${L.rea} (Chamber of Commerce ${L.cciaa}), registered office ${addr}. Legal representative: ${L.owner}. Contact: PEC ${L.pec} — email ${L.publicEmail}.`,
    es: `El Responsable del tratamiento de datos es ${L.denomination} (${L.legalForm.es}), N.º IVA ${L.vatId}, REA ${L.rea} (Cámara de Comercio ${L.cciaa}), sede legal en ${addr}. Representante legal: ${L.owner}. Contacto: PEC ${L.pec} — email ${L.publicEmail}.`,
    pt: `O Responsável pelo tratamento dos dados é ${L.denomination} (${L.legalForm.pt}), NIF ${L.vatId}, REA ${L.rea} (Câmara de Comércio ${L.cciaa}), sede legal em ${addr}. Representante legal: ${L.owner}. Contacto: PEC ${L.pec} — email ${L.publicEmail}.`,
  };
  return map[lang] || map.it;
};
